import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from '@bibliocommons/base-links';
import { availabilityShape, catalogBibShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { SuggestForPurchaseButtonContainer } from 'app/components/bibs/shared/SuggestForPurchaseButton';

import './AvailabilityErrorInfo.scss';

export function AvailabilityErrorInfo({ realtimeAvailability, availabilityError, currentLibrary, catalogBib, intl }) {
  const isMatchError = availabilityError === 'AvailabilityMatchError';

  function renderErrorMessage() {
    const totalCopies = realtimeAvailability && realtimeAvailability.get('totalCopies');
    const messageId = totalCopies === 0 ? 'errors.NoAvailableCopies' : `errors.${availabilityError}`;
    const defaultMessage = intl.formatMessage({ id: 'availability_api_failure' });
    const values = { libraryName: currentLibrary.get('fullName') };

    return (
      <strong className="error-message">
        <FormattedMessage defaultMessage={defaultMessage} id={messageId} values={values} />
      </strong>
    );
  }

  function renderSearchLink() {
    const searchUrl = `/v2/search?query=${encodeURIComponent(catalogBib.getIn(['brief', 'title']))}&searchType=title`;

    return (
      <Link className="search-link" href={searchUrl} dataKey="search-link">
        <FormattedMessage id="search_related_versions" />
      </Link>
    );
  }

  return (
    <div className="cp-availability-error-info">
      {renderErrorMessage()}
      {renderSearchLink()}
      {isMatchError && (
        <div>
          <div className="match-error-disclaimer">
            <FormattedMessage id="record_provided_by" />
          </div>
          <SuggestForPurchaseButtonContainer />
        </div>
      )}
    </div>
  );
}

AvailabilityErrorInfo.propTypes = {
  availabilityError: PropTypes.string,
  realtimeAvailability: availabilityShape,
  catalogBib: catalogBibShape.isRequired,
  currentLibrary: libraryShape.isRequired
};

export default injectIntl(AvailabilityErrorInfo);
